"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ItemExpand = exports.ItemBefore = exports.ItemAfter = void 0;
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _link = _interopRequireDefault(require("@clayui/link"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "className"],
  _excluded2 = ["children", "className"],
  _excluded3 = ["children", "className", "href"],
  _excluded4 = ["children", "className", "dismissible", "displayType", "large"],
  _excluded5 = ["children", "closeButtonProps", "href", "innerElementProps", "withClose", "spritemap"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var ItemAfter = exports.ItemAfter = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("span", _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'label-item label-item-after'),
    ref: ref
  }), children);
});
ItemAfter.displayName = 'ClayLabelItemAfter';
var ItemBefore = exports.ItemBefore = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    className = _ref2.className,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement("span", _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'label-item label-item-before'),
    ref: ref
  }), children);
});
ItemBefore.displayName = 'ClayLabelItemBefore';
var ItemExpand = exports.ItemExpand = /*#__PURE__*/_react.default.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    className = _ref3.className,
    href = _ref3.href,
    otherProps = _objectWithoutProperties(_ref3, _excluded3);
  var TagName = href ? _link.default : 'span';
  return /*#__PURE__*/_react.default.createElement(TagName, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'label-item label-item-expand'),
    href: href,
    ref: ref
  }), children);
});
ItemExpand.displayName = 'ClayLabelItemExpand';
var OldLabel = /*#__PURE__*/_react.default.forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
    className = _ref4.className,
    dismissible = _ref4.dismissible,
    _ref4$displayType = _ref4.displayType,
    displayType = _ref4$displayType === void 0 ? 'secondary' : _ref4$displayType,
    _ref4$large = _ref4.large,
    large = _ref4$large === void 0 ? false : _ref4$large,
    otherProps = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_react.default.createElement("span", _extends({}, otherProps, {
    className: (0, _classnames.default)('label', className, _defineProperty({
      'label-dismissible': dismissible,
      'label-lg': large
    }, "label-".concat(displayType), displayType)),
    ref: ref
  }), children);
});
OldLabel.displayName = 'ClayLabel';
function forwardRef(component) {
  return /*#__PURE__*/_react.default.forwardRef(component);
}
var Label = forwardRef(function (_ref5, ref) {
  var children = _ref5.children,
    closeButtonProps = _ref5.closeButtonProps,
    href = _ref5.href,
    _ref5$innerElementPro = _ref5.innerElementProps,
    innerElementProps = _ref5$innerElementPro === void 0 ? {} : _ref5$innerElementPro,
    _ref5$withClose = _ref5.withClose,
    withClose = _ref5$withClose === void 0 ? true : _ref5$withClose,
    spritemap = _ref5.spritemap,
    otherProps = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_react.default.createElement(OldLabel, _extends({
    dismissible: withClose && !!closeButtonProps
  }, otherProps, {
    ref: ref
  }), !withClose && children, withClose && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ItemExpand, _extends({}, innerElementProps, {
    href: href
  }), children), closeButtonProps && /*#__PURE__*/_react.default.createElement(ItemAfter, null, /*#__PURE__*/_react.default.createElement("button", _extends({}, closeButtonProps, {
    className: (0, _classnames.default)(closeButtonProps.className, 'close'),
    type: "button"
  }), /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "times-small"
  })))));
});
Label.displayName = 'ClayLabel';
Label.ItemAfter = ItemAfter;
Label.ItemBefore = ItemBefore;
Label.ItemExpand = ItemExpand;
var _default = exports.default = Label;